var date = {
  "formats": {
    "default": "%m/%d/%Y",
    "short": "%b %d",
    "long": "%B %d, %Y",
    "day_long": "%A %e",
    "datepicker2": "%b %e, %Y",
    "short_day": "%a, %b %e",
    "month_year": "%b %Y",
    "long_dow": "%a, %B %d, %Y",
    "day_only": "%d",
    "long_month_only": "%B",
    "long_year_only": "%Y",
    "long_month_year": "%B %Y",
    "myenlighten_month": "%m/%Y",
    "admin_date": "%Y/%m/%d",
    "graph": {
      "long": "%a %b %e %Y",
      "x_axis": {
        "day": "%b %e",
        "week": "%b %e"
      }
    },
    "jquery": {
      "datepicker": "m/d/y",
      "datepicker2": "M d, yy",
      "power_playback": "ddd MMM d, yyyy hh:mm tt",
      "myenlighten": "mm/dd/yyyy",
      "datejs_formatter": "M/dd/yyyy",
      "myenlighten_month": "mm/yyyy",
      "myenlighten_overview": "D, M d, yyyy",
      "datejs_month_formatter": "M/yyyy"
    },
    "js": {
      "short_month": "%b",
      "short_day_year": "%a, %b %e, %Y",
      "short_month_day": "%B&nbsp;%d,&nbsp;%Y",
      "short_month_day_time": "%B %d, %Y – %-I:%M",
      "short_dow_month_day_time": "%a, %B %d, %Y – %-I:%M",
      "month_day_year_time": "%B %d, %Y %-I:%M %p"
    }
  },
  "day_names": ["Domingo", "Segunda-Feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"],
  "abbr_day_names": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  "month_names": [null, "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
  "abbr_month_names": [null, "Jan", "Fev", "Mar", "Abr", "Maio", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
  "order": ["Ano", "mês", "dia"],
  "range": {
    "presets": {
      "today": "Dziś",
      "last7Days": "Past 7 Days",
      "monthToDate": "Month to Date",
      "yearToDate": "Year to Date"
    }
  }
};
module.exports = date;